import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { TypeLotsMAPA } from '../models/TypeLotsMAPA';
import { Lot } from '../models/Lot';
import { Step4 } from '../../../../shared/models/component-messages/mapaIN/step4';
import { MapaINControlNames } from '../service/mapaINControleNames';
import { ArrayPopTools } from '../../../../shared/services/array-pop-tools';
import { RadioCheckBoxEnum } from '../../../common/radio.checkbox.enums';

@Component({
  selector: 'app-type-lotsMAPA',
  templateUrl: './type-lotsMAPA.component.html',
  styleUrls: ['./type-lotsMAPA.component.scss']
})
export class TypeLotsMAPAComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeLotsMAPA';
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	@Input() lots: TypeLotsMAPA;
	@Input() alloti: any;

  public radioButtonValue : string;
  public radioButtonCtrlName : string;
  public oui = RadioCheckBoxEnum.ouiValue;
  public non = RadioCheckBoxEnum.nonValue;


    public step4 = new Step4();

  constructor() { }

  public ngOnInit() {

    if (!this.lots) {
      this.lots = new TypeLotsMAPA();
    }
   this.radioButtonValue = this.alloti;
  }


  addlot(){
		this.lots.lot.push(new Lot());
	}

  removelot(i){
    ArrayPopTools.pop(this.lots.lot, i, this.parentForm, this.getUid());
	}



  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }

  isMarcheAlloti() {
  if (this.parentForm.controls[this.getUid() + '_SepAtt_marcheAlloti'].value === RadioCheckBoxEnum.ouiValue) {
    if(this.lots.lot.length === 0) {
      this.addlot();
    }
     return true;
  }
  else {
     return false;
  }
  }

}

